import { FC, SVGProps } from 'react';

export const AddIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 5.91668C10.4307 5.91668 5.91671 10.4307 5.91671 16C5.91671 21.5681 10.4308 26.0833 16 26.0833C21.5693 26.0833 26.0834 21.5681 26.0834 16C26.0834 10.4307 21.5693 5.91668 16 5.91668ZM4.08337 16C4.08337 9.41818 9.41821 4.08334 16 4.08334C22.5818 4.08334 27.9167 9.41818 27.9167 16C27.9167 22.5805 22.5819 27.9167 16 27.9167C9.41814 27.9167 4.08337 22.5805 4.08337 16Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.9167 11.9714C16.9167 11.4651 16.5063 11.0547 16 11.0547C15.4938 11.0547 15.0834 11.4651 15.0834 11.9714V15.0858H11.9657C11.4595 15.0858 11.0491 15.4962 11.0491 16.0025C11.0491 16.5087 11.4595 16.9191 11.9657 16.9191H15.0834V20.0293C15.0834 20.5356 15.4938 20.946 16 20.946C16.5063 20.946 16.9167 20.5356 16.9167 20.0293V16.9191H20.032C20.5383 16.9191 20.9487 16.5087 20.9487 16.0025C20.9487 15.4962 20.5383 15.0858 20.032 15.0858H16.9167V11.9714Z"
			fill="currentColor"
		/>
	</svg>
);
